import { Typography, Grid2 as Grid } from "@mui/material";
import JiraIntegrationImg from "../../assets/pngs/jiraIntegration.png";

const JiraIntegration = () => {

    return (
        <>
            <Grid container direction={"column"} spacing={2}>
                <Grid size={8}>
                    <Typography
                        fontWeight={"bold"}
                        fontFamily={"Inter"}
                        fontSize={"16px"}
                        color={"#303030"}
                    >
                        Jira Integration
                    </Typography>
                </Grid>

                <Grid mt={0}>
                    <img
                        src={JiraIntegrationImg}
                        alt=""
                        style={{
                            width: '100%',
                            height: 'auto',
                            objectFit: 'cover',
                        }} />
                </Grid>
            </Grid>
        </>
    )
}
export default JiraIntegration;